import * as d3 from 'd3-geo'

export default (point, shape) => {
  if (!point || !shape) return false

  return d3.geoContains(shape, [point.lng, point.lat])
}
